// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"3959":"fa1f4cf4e5293fb5fab4","9064":"33c3b89a6c1e58ca4801"}[chunkId] + ".css";
};